import digitMask from '@/components/forms/input/masks/digit-mask';
import percentMask from '@/components/forms/input/masks/percent-mask';
import CurrencyMaskClass from '@/components/forms/input/masks/currency/currency-mask-class';
import PercentMaskClass from '@/components/forms/input/masks/percent/percent-mask-class';
/**
 * @mixin
 */
export default {
	data() {
		return {
			withFocus: false,
			masks: {
				currency: new CurrencyMaskClass(),
				digit: digitMask,
				percent: percentMask,
				percentFormat: new PercentMaskClass()
			}
		};
	},
	props: {
		value: {
			type: [String, Number],
			default: ''
		},
		labelText: {
			type: String,
			default: ''
		},
		placeholder: {
			type: String,
			default: ''
		},
		type: {
			type: String,
			default: 'text'
		},
		textAlign: {
			type: String
		},
		mask: {
			type: String,
			validator(value) {
				// The value must match one of these strings
				return [
					'currency',
					'digit',
					'percent',
					'percentFormat'
				].includes(value);
			}
		},
		selectAllonFocus: {
			type: Boolean,
			default: false
		},
		restrictAlphabet: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		this.processFormatter(new Event('mounted'));
	},
	updated() {
		this.processFormatter(new Event('updated'));
	},
	computed: {
		inputElementStyle() {
			let style;

			if (this.textAlign) {
				style = `text-align:${this.textAlign}`;
			}

			return style;
		},
		formatter() {
			let func = () => {};

			if (this.mask) {
				func = this.masks[this.mask].format;
			}

			return func;
		},
		parser() {
			let func = val => val;

			if (this.mask) {
				func = this.masks[this.mask].parse;
			}

			return func;
		}
	},
	methods: {
		async inputSearchText(e) {
			await this.$emit('input', this.parser(this.$refs.input.value));
			await this.$nextTick();
			this.processFormatter(e);
		},
		updateSearchText() {
			this.$emit('change', this.parser(this.$refs.input.value));
		},
		blurSearchText(e) {
			this.processFormatter(e);
			this.$emit('blur', this.parser(this.$refs.input.value));
		},
		onKeyUp(e) {
			this.$emit('keyup', e);

			if (e.key === 'Enter' || e.keyCode === 13) {
				// Do something
				this.$emit('enter', e);
			}

			if (e.key !== 'Tab') {
				this.processFormatter(e);
			}
		},
		onKeyDown(e) {
			if (e.key === 'Tab') {
				this.withFocus = true;
			}

			if (this.restrictAlphabet) {
				this.rAlphabet(e);
			}

			this.processFormatter(e);
		},
		onInputFocus(e) {
			this.$emit('focus', e);

			if (this.selectAllonFocus) {
				e.target.select();
			}
		},
		onClick(e) {
			this.$emit('searchTextClicked');
			this.$emit('click', e);
		},
		processFormatter(e) {
			if (this.$refs.input) {
				this.formatter(this.$refs.input, e, this);
			}
		},
		rAlphabet(e) {
			let k = e.which || e.keycode;
			let result = (k >= 48 && k <= 57) || k == 47;

			if (!result) {
				e.preventDefault();
			}
		}
	}
};
